import Box from 'components/Box';
import React from 'react';
import { LogoBox, ShopAddress, ShopName, ShopPhone, TicketBox } from './components';
import { IParamsReportSalaryStaff } from 'features/report/services/types/review';
import moment from 'moment';
import shopSelectors from 'services/shop/selectors';
import { formatShopInfo } from '../../utils';
import Text from 'components/Text';

const renderTime = (params: IParamsReportSalaryStaff | undefined) => {
  if (!params) return '';
  const startDateStr = moment(params?.startDate, 'MM/DD/YYYY').format('MM/DD/YYYY');
  const endDateStr = moment(params?.endDate, 'MM/DD/YYYY').format('MM/DD/YYYY');
  if (params?.startDate == params?.endDate) {
    return startDateStr;
  }
  return `${startDateStr} - ${endDateStr}`;
};

type Props = {
  children?: any;
  params?: IParamsReportSalaryStaff;
};
const PayrollReceiptWrapper = ({ children, params }: Props) => {
  const shopInfo = shopSelectors.data.shopInfo();
  const shopInfoFormatted = formatShopInfo(shopInfo);
  return (
    <Box px='3' className="center" overflow="auto">
      <TicketBox>
        <>
          <LogoBox>
            <ShopName>{shopInfoFormatted.name}</ShopName>
            <ShopAddress>{shopInfoFormatted.streetAddress}</ShopAddress>
            <ShopAddress>{shopInfoFormatted.cityStateZip}</ShopAddress>
            <ShopPhone>{shopInfoFormatted.phone}</ShopPhone>
          </LogoBox>
          <Box className="center">
            <Text printMode variant="CONTENT_2" color="text_2">
              {renderTime(params)}
            </Text>
          </Box>
        </>
        <Box px='3'>
          {children}
        </Box>
      </TicketBox>
    </Box>
  );
};

export default PayrollReceiptWrapper;
